import {
  Button,
  Card,
  Container,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import Help from "~/components/common/Help";
import EditProviderTeamDialog from "./EditProviderTeamDialog";
import { GetProviderSelectItemsQuery, TeamsQuery } from "~/graphql/__generated__/graphql";
import { GET_PROVIDER_SELECT_ITEMS } from "~/queries/forms";

const TEAMS_QUERY = gql(`
  query Teams
  @permission(requires: manageTeams) {
    team {
      id
      name
      teamProviders {
        provider {
          id
          firstName
          lastName
        }
      }
    }
  }
`);

const TabProviderTeams = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentTeam, setCurrentTeam] = useState<TeamsQuery["team"][number] | null>(null);

  const { data, refetch } = useQuery<TeamsQuery>(TEAMS_QUERY);
  const { data: providerSelectItems } = useQuery<GetProviderSelectItemsQuery>(GET_PROVIDER_SELECT_ITEMS);

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Team Name
                <Help text="Name of the provider team" />
              </TableCell>
              <TableCell>
                Providers
                <Help text="Number of providers in this team" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.team.map((team) => (
              <TableRow key={team.id}>
                <TableCell>
                  {team.name}
                  <IconButton
                    size="small"
                    onClick={() => {
                      setCurrentTeam(team);
                      setDialogOpen(true);
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
                <TableCell>{team.teamProviders.map((tp) => `${tp.provider?.firstName} ${tp.provider?.lastName}`).join(", ")}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={2}>
                <Button
                  onClick={() => {
                    setCurrentTeam(null);
                    setDialogOpen(true);
                  }}
                  size="small"
                  startIcon={<AddCircleOutlineIcon fontSize="small" />}
                >
                  Add New Team
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>

      <EditProviderTeamDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          setCurrentTeam(null);
        }}
        onSuccess={() => refetch()}
        team={currentTeam}
        providerSelectItems={providerSelectItems?.provider || []}
      />
    </Container>
  );
};

export default TabProviderTeams;
